
import { getServiceName } from "@/commons/commonUtility";
import { MANGA_MEE_LINKAGE_ID } from "@/commons/linkage/sites/manga_mee";
import { LinkageItem } from "@/modules/linkage/linkageInfo";
import { computed, defineComponent } from "vue";

export default defineComponent({
    name: "LinkageTerms",
    props: {
        initialsCalss: { type: String, required: true },
    },
    setup(props) {
        const { linkageInfo, serviceTermUrl } = LinkageItem.inject();

        const serviceName = getServiceName(linkageInfo.linkageId);
        const initialLetterClass = computed(() => props.initialsCalss.trim());
        let termTitle = `${serviceName}会員規約`;
        if (linkageInfo.linkageId === MANGA_MEE_LINKAGE_ID) {
            termTitle = `${serviceName}利用規約`;
        }

        return {
            initialLetterClass,
            serviceName,
            serviceTermUrl,
            linkageInfo,
            termTitle
        };
    },
});
